export const colors = {
  aim: {
    primary: '#00BEAB',
  },
  campaigntrack: {
    primary: '#16213A',
  },
  campaigntrack_australia: {
    primary: '#16213A',
  },
  campaigntrack_commercial: {
    primary: '#000000',
  },
  campaigntrack_new_zealand: {
    primary: '#16213A',
  },
  content_house: {
    primary: '#E95B35',
  },
  engage: {
    primary: '#8CBFDC',
  },
  realhub: {
    primary: '#02B7E2',
  },
  sprint_solutions_print: {
    primary: '#215365',
  },
  sprint_solutions_signs: {
    primary: '#215365',
  },
}

export default {
  colors,
} 
